import React from "react";
import { Routes, Route } from "react-router-dom";
import EcoIndex from "../../EcoIndex";
import OrganiserDetailsSidebar from "./OragniserDetailsSidebar";
import OrganizerData from "./OrganizerData";

const Organizer = () => {
  return (
    <div className="organizer">
      <EcoIndex />
      <div className="main-content">
        <OrganiserDetailsSidebar />
        
        <Routes>
          {/* Match the exact path you want */}
          <Route path="Organizer-info" element={<OrganizerData />} />
          {/* Add other routes if needed */}
        </Routes>
      </div>
    </div>
  );
};

export default Organizer;
